var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.notifications, function (item, index) {
        return _c("base-notificator", {
          key: index,
          staticClass: "_my-2",
          attrs: { "can-close": false, message: item.message, type: item.type },
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_mb-6" },
        _vm._l(_vm.groupedAvailablePaymentMethodItems, function (paymentGroup) {
          return _c(
            "adyen-payment-method-group",
            {
              key: paymentGroup.title,
              attrs: {
                title: paymentGroup.title,
                "collapsed-title": paymentGroup.collapsedTitle,
                "is-title-visible": paymentGroup.isTitleVisible,
                "is-collapsible": paymentGroup.isCollapsible,
                "is-collapsed": paymentGroup.isCollapsed,
                "data-qa": _vm.getGroupDataQa(paymentGroup.sectionType),
              },
              on: {
                toggle: function ($event) {
                  return _vm.toggleGroupVisibility(paymentGroup.sectionType)
                },
              },
            },
            _vm._l(paymentGroup.paymentMethods, function (paymentMethod) {
              return _c(
                "adyen-payment-method-option",
                {
                  key: paymentMethod.paymentDataSource,
                  attrs: {
                    "payment-method": paymentMethod,
                    "is-selected": paymentMethod.isSelected,
                  },
                  on: {
                    select: function ($event) {
                      return _vm.onPaymentMethodSelect(
                        paymentMethod.paymentDataSource
                      )
                    },
                  },
                },
                [
                  _c(
                    paymentMethod.form,
                    _vm._b(
                      {
                        ref: "paymentMethodForm",
                        refInFor: true,
                        tag: "component",
                        staticClass: "_pa-3",
                        on: {
                          "form-details-changed": _vm.onPaymentMethodFormChange,
                        },
                      },
                      "component",
                      _vm.getPaymentMethodProps(paymentMethod),
                      false
                    )
                  ),
                ],
                1
              )
            }),
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      !_vm.isPaymentMethodSelected && !_vm.isProceedPaymentBlocked
        ? _c("div", { staticClass: "gfu-field has-error" }, [
            _c(
              "div",
              {
                staticClass: "gfu-field__error",
                attrs: { "data-qa": "payment-method-required" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.Resources.Checkout.InvalidPaymentOptionErrorMessage
                    ) +
                    "\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("content"),
      _vm._v(" "),
      _vm.requireAcceptTos && !_vm.isProceedPaymentBlocked
        ? _c("terms-of-service-checkbox-field", {
            staticClass: "_mt-6",
            attrs: { name: "model.termsAccepted" },
            model: {
              value: _vm.model.termsAccepted,
              callback: function ($$v) {
                _vm.$set(_vm.model, "termsAccepted", $$v)
              },
              expression: "model.termsAccepted",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "adyenRedirectAction" }),
      _vm._v(" "),
      _vm._t("actions", null, null, {
        onSubmit: _vm.onSubmit,
        isProceedPaymentBlocked: _vm.isProceedPaymentBlocked,
        paymentMethodErrorMessage: _vm.paymentMethodErrorMessage,
        isProcessing: _vm.isProcessing,
        grantOrderAccess: _vm.paymentSubmission.grantOrderAccess,
      }),
      _vm._v(" "),
      _vm.isAdyenPaymentModalVisible
        ? _c("adyen-payment-modal", {
            attrs: {
              "project-id": _vm.projectId,
              "is-modal-visible": _vm.isAdyenPaymentModalVisible,
              "is-instant": _vm.isInstantPaymentSelected,
              "order-code": _vm.effectiveOrderCode,
              "provider-payment-id": _vm.currentProviderPaymentID,
              "checkout-mode": _vm.effectiveCheckoutMode,
              "payment-data-source": _vm.selectedPaymentMethod,
              "store-credit-card": _vm.shouldStoreCreditCard,
              "payment-type": _vm.model.paymentType,
              "payment-action": _vm.paymentActionData,
              "available-payment-methods": _vm.availablePaymentMethods,
            },
            on: {
              close: _vm.onAdyenPaymentModalClose,
              "checkout-mode-changed": _vm.onCheckoutModeChanged,
              "payment-method-changed": _vm.onPaymentMethodChanged,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }